// JSON-LD Schema generators for structured data

const SITE_URL = 'https://bestoddscorp.com';

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Best Odds Corp',
    url: SITE_URL,
    logo: `${SITE_URL}/assets/images/boc_logo_240x90_white-1771394304209.png`,
    description: 'Las Vegas-based creative agency delivering exceptional marketing execution, brand strategy, and production services.',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Las Vegas',
      addressRegion: 'NV',
      addressCountry: 'US',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+1-702-546-6337',
      contactType: 'Customer Service',
      email: 'hello@bestoddscorp.com',
      availableLanguage: 'English',
    },
    sameAs: [
      'https://www.facebook.com/bestoddscorp',
      'https://twitter.com/bestoddscorp',
      'https://www.linkedin.com/company/best-odds-corp',
    ],
    foundingDate: '2000',
    foundingLocation: 'Las Vegas, Nevada',
  };
}

export function getServiceSchema(service: {
  name: string;
  description: string;
  slug: string;
  category: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: service.name,
    description: service.description,
    provider: {
      '@type': 'Organization',
      name: 'Best Odds Corp',
      url: SITE_URL,
    },
    areaServed: 'US',
    serviceType: service.category,
    url: `${SITE_URL}/services/${service.slug}`,
  };
}

export function getFAQPageSchema(faqs: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

// Helper component to inject JSON-LD into pages
export function JSONLDScript({ data }: { data: any }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      suppressHydrationWarning
    />
  );
}
